<template>
  <header
    class="flex justify-between items-center p-16 fixed w-full backdrop-blur-sm"
  >
    <RevButtonIcon
      :aria-label="i18n(translations.newChat)"
      :icon="IconPlusInCircle"
      size="small"
      :to="{ name: SHOPPING_ASSISTANT_NEW }"
      variant="ghost"
      @click="emit('click', { name: 'new_chat' })"
    />
    <div class="flex">
      <h1 class="heading-3">{{ i18n(translations.modalTitle) }}</h1>
      <IconSparklesFilled size="small" />
    </div>

    <RevButtonIcon
      :aria-label="i18n(translations.closeChat)"
      :icon="IconCrossSmall"
      size="small"
      variant="ghost"
      @click="emit('click', { name: 'close_chat' })"
    />
  </header>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { IconCrossSmall } from '@ds/icons/IconCrossSmall'
import { IconPlusInCircle } from '@ds/icons/IconPlusInCircle'
import { IconSparklesFilled } from '@ds/icons/IconSparklesFilled'

import { SHOPPING_ASSISTANT_NEW } from '../../routes.constants'
import translations from '../ShoppingAssistant.translations'

const i18n = useI18n()

const emit = defineEmits<{
  (e: 'click', payload: { name: string }): void
}>()
</script>
